import { scrollToElement } from 'scroll-utils';

class NextSectionButton extends HTMLElement {
  connectedCallback() {
    const current = this.closest('.shopify-section');
    let next = current ? current.nextElementSibling : null;
    while (next && !next.classList.contains('shopify-section')) {
      next = next.nextElementSibling;
    }

    // Nothing below us on the page — no sensible target to scroll to, so don't show a button
    // that does nothing.
    if (!next) {
      this.hidden = true;
      return;
    }

    this.querySelector('button').addEventListener('click', () => scrollToElement(next));
  }
}

customElements.define('next-section-button', NextSectionButton);
